<template>
  <div class="date-range-picker">
    <v-layout row>
      <v-flex xs6>
        <date-picker
          :id="fromId"
          :value="from"
          :label="labelFrom"
          :max="max"
          :prepend-icon="prependIcon"
          :allowed-dates="allowedDatesFrom"
          class="t-date-from-field"
          :disabled="disabled"
          clearable
          @input="onDateFromChange"
        />
      </v-flex>

      <v-flex xs6>
        <date-picker
          :id="toId"
          ref="pickerDateTo"
          :value="to"
          :label="labelTo"
          :max="max"
          :prepend-icon="prependIcon"
          :allowed-dates="allowedDatesTo"
          class="t-date-to-field"
          clearable
          :disabled="disabled"
          @input="onDateToChange"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import DatePicker from '@/components/ui/DatePicker'

  export default {
    name: 'DateRangePicker',
    components: {
      DatePicker
    },
    inheritAttrs: false,
    props: {
      from: {
        type: String,
        default: undefined
      },
      to: {
        type: String,
        default: undefined
      },
      max: {
        type: String,
        default: ''
      },
      prependIcon: {
        type: String,
        default: ''
      },
      labelFrom: {
        type: String,
        default: 'From'
      },
      labelTo: {
        type: String,
        default: 'To'
      },
      allowedDatesFrom: {
        type: Function,
        default: null
      },
      allowedDatesTo: {
        type: Function,
        default: null
      },
      independent: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      fromId () {
        if (this.$attrs.id != null) {
          return `${this.$attrs.id}-from`
        }
      },
      toId () {
        if (this.$attrs.id != null) {
          return `${this.$attrs.id}-to`
        }
      }
    },
    methods: {
      onDateFromChange (value) {
        if (!this.independent) {
          this.$refs.pickerDateTo.setPickerVisible(true)
        }

        this.$emit('update:from', value)
        this.$emit('change:from', value)
        this.$emit('input:from', value)
      },
      onDateToChange (value) {
        this.$emit('update:to', value)
        this.$emit('change:to', value)
        this.$emit('input:to', value)
      }
    }
  }
</script>
